<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-toggle-menu-button></app-toggle-menu-button>
    </ion-buttons>

    <ion-title>
      <div class="ion-text-wrap">
        {{ title }}
      </div>
    </ion-title>

    <ion-progress-bar
      *ngIf="isLoading$ | async"
      type="indeterminate"
    ></ion-progress-bar>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card>
    <ion-card-content>
      <app-material-form
        #formElement
        [defaultValues]="defaultValues"
        [displaySettings]="displaySettings"
      >
      </app-material-form>
    </ion-card-content>
  </ion-card>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-tabs>
      <ion-tab-bar>
        <ion-tab-button (click)="onSave($event)">
          <ion-icon name="save"></ion-icon>
          <ion-label>
            {{ texts.general.save | translate }}
          </ion-label>
        </ion-tab-button>

        <ion-tab-button (click)="onCancel($event)">
          <ion-icon name="arrow-back"></ion-icon>
          <ion-label>{{ texts.general.cancel | translate }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-toolbar>
</ion-footer>
